import { Icon } from "armstrong-react";
import React from "react";
import { IToolbarProps } from "..";
import { hasLinks, insertLink } from "../../plugins/link/linkUtils";
import { ToolbarButton } from "../toolbarButton";

import "./toggleLinkButton.scss";

export const ToggleLinkButton = ({ editorRef }: IToolbarProps) => {
  // Edit/ remove link UI is in the tooltip
  const disabled = hasLinks(editorRef.value);

  return (
    <div className="slate-toolbar-button__link">
      <ToolbarButton disabled={disabled} onClick={() => insertLink(editorRef, { isNew: true })} title="Add link">
        <Icon icon={Icon.Icomoon.link} />
      </ToolbarButton>
    </div>
  );
};
